/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBuyerInfo} from '../api'

 export const useQueryGetBuyerInfo = createReactQueryHook('getBuyerInfo', getBuyerInfo)
